import { Box } from '@material-ui/core'
import { useUser } from 'components/providers/UserProvider'
import { useTranslation } from 'react-i18next'
import { SalesChannelsConnector } from '../account/SalesChannelConnector'
import { ShopifyActiveBox } from './ShopifyActiveBox'

interface ShopifyConnectProps {
  noHelperText?: boolean
  big?: boolean
  onConnect?: () => void
}

export const ShopifyConnect = ({}: // noHelperText = false,
// big = false,
ShopifyConnectProps): JSX.Element => {
  const { user } = useUser()
  const { t } = useTranslation()

  if (!user) return <></>

  const userConnected = () => {
    return (
      <div className="d-flex flex-wrap mt-2">
        {user.assignedShopifyShops
          .filter((shop) => !shop.disabled)
          .sort((a, b) => a.shop.localeCompare(b.shop))
          .map((shop_data) => {
            return (
              <div style={{ marginRight: '20px' }} key={shop_data.shop}>
                <ShopifyActiveBox shop={shop_data.shop}></ShopifyActiveBox>
              </div>
            )
          })}
      </div>
    )
  }
  const userNotConnected = () => {
    return (
      <SalesChannelsConnector
        type="Shopify"
        onBoxClick={() => (window.location.href = process.env.REACT_APP_SHOPIFY_INSTALL_LINK!)}
        title={t('connectShopify.connectButton')}
        icon="fa-brands fa-shopify"
        active={false}
        buttons={[]}
      />
    )
  }

  return (
    <Box padding={0}>
      {user.assignedShopifyShops.filter((shop) => !shop.disabled).length > 0
        ? userConnected()
        : userNotConnected()}
    </Box>
  )
}
